/**
 * Redux slice for course comments
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommentsState, CourseComment } from '../types';

const initialState: CommentsState = {
  courseComments: {},
  loading: false,
  error: null,
};

const commentsSlice = createSlice({
  name: 'comments',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setCourseComments: (state, action: PayloadAction<{ courseId: string; comments: CourseComment[] }>) => {
      state.courseComments[action.payload.courseId] = action.payload.comments;
    },
    addComment: (state, action: PayloadAction<CourseComment>) => {
      const { courseId } = action.payload;
      if (!state.courseComments[courseId]) {
        state.courseComments[courseId] = [];
      }
      state.courseComments[courseId].unshift(action.payload); // Add to beginning (newest first)
    },
    updateComment: (state, action: PayloadAction<CourseComment>) => {
      const { courseId, id } = action.payload;
      if (state.courseComments[courseId]) {
        const index = state.courseComments[courseId].findIndex((c) => c.id === id);
        if (index !== -1) {
          state.courseComments[courseId][index] = action.payload;
        }
      }
    },
    removeComment: (state, action: PayloadAction<{ courseId: string; commentId: string }>) => {
      const { courseId, commentId } = action.payload;
      if (state.courseComments[courseId]) {
        state.courseComments[courseId] = state.courseComments[courseId].filter(
          (c) => c.id !== commentId
        );
      }
    },
  },
});

export const {
  setLoading,
  setError,
  setCourseComments,
  addComment,
  updateComment,
  removeComment,
} = commentsSlice.actions;

export default commentsSlice.reducer;

